var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-loading",style:(!_vm.hasCustomClass && {
    width: _vm.type === 'circle' ? _vm.currentHeight : _vm.currentWidth,
    height: _vm.currentHeight,
    borderRadius: _vm.type === 'circle' ? '100%' : _vm.borderRadius,
  }),attrs:{"role":"progressbar"}})}
var staticRenderFns = []

export { render, staticRenderFns }